export default __webpack_public_path__ + "static/media/video-countdown.7c9d85fe.svg";